module.exports = "/fonts/eppt-picturemark-d-d63366e836f001a21eb6e8700a00c381.svg";